// extracted by mini-css-extract-plugin
export default {"header":"styles_header__cKqus","body":"styles_body__F6agu","form":"styles_form__6VY2J"};